import Helper from '../../../client/helper.js'
import Network from '../../../client/network.js'

export default class
{
	static sync_pattern(button)
	{
		Helper.confirm(Helper.message('#message-download_pattern_confirm'), () =>
		{
			const loader = $(button).find('._loader')
			loader.addClass('css-loader')

			const data = new FormData()
			data.set('__action', 'sync_pattern')

			Network.post(
				location.pathname,
				data,
				() => loader.removeClass('css-loader'),
				true,
			)
		})
	}
}
